<template>
  <vxe-modal v-model="visible" :loading="loading" title="title.coldChainEdit" type="confirm" width="50%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="{span:8}" :model="order" :wrapper-col="{span:16}">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.conveyance')" prop="conveyance">
            <vxe-select v-model="order.conveyance.id" :options="conveyances" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.tempControlMode')" prop="tempControlMode">
            <vxe-select v-model="order.tempControlMode.id" :options="tempControlModes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.departureTime')" prop="departureTime">
            <vxe-date-picker v-model="order.departureTime" style="width: 100%" type="datetime"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.arrivalTime')" prop="arrivalTime">
            <vxe-date-picker v-model="order.arrivalTime" style="width: 100%" type="datetime"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.departureTemp')" prop="departureTemp">
            <vxe-number-input v-model="order.temperature.departureTemp" style="width: 100%;"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.arrivalTemp')" prop="arrivalTemp">
            <vxe-number-input v-model="order.temperature.arrivalTemp" style="width: 100%;"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.maximumTemp')" prop="maximumTemp">
            <vxe-number-input v-model="order.temperature.maximumTemp" style="width: 100%;"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.minimumTemp')" prop="minimumTemp">
            <vxe-number-input v-model="order.temperature.minimumTemp" style="width: 100%;"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import Vue from 'vue'
import api from '@/api'
import { WAREHOUSE } from '@/store/mutation-types'
import { findOne, post } from '@/api/Api'
import { AsnOrder } from '@/api/dto/order/AsnOrder'
import { getDictionaries } from '@/utils/util'

export default {
  name: 'ColdChainEditor',
  data() {
    return {
      visible: false,
      loading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      order: new AsnOrder(),
      conveyances: [],
      tempControlModes: []
    }
  },
  created() {
    getDictionaries('CONVEYANCE').then(result => {
      this.conveyances = result
      return getDictionaries('TEMP_CONTROL_MODE')
    }).then(result => {
      this.tempControlModes = result
    })
  },
  methods: {
    open(id) {
      this.visible = true
      this.loading = true
      findOne('asnOrderFactory', { id: id }).then(res => {
        if (res.success) {
          this.order = new AsnOrder(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const order = this.order.toJSONObject()
      order.warehouse = this.warehouse
      post(api.receivingAsnSave, { type: 'normalAsn' }, order).then(res => {
        if (res.success) {
          this.$emit('success', res.result)
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    }
  }
}
</script>